import Vue from "vue";
import config from "./../utils/config";
// import * as math from "mathjs";
// 定义各种状态过滤器

// // 精度问题
// function printFn(value) {
//   const precision = 14;
//   return Number(math.format(value, precision));
// }

function changeNum(value) {
  value = parseFloat(value);
  //判断是否有小数点
  var s = value.toString().indexOf(".");
  if (s == -1) {
    // 是整数
    return (
      (value || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,") + ".00"
    );
  } else {
    // 是小数
    var arr = value.toString().split(".");
    if (arr.length > 1 && arr[1].length < 2) {
      // 一位小数
      return (
        (arr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,") +
        "." +
        arr[1] +
        "0"
      );
    } else {
      // 两位小数以上
      return (
        (arr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,") +
        "." +
        arr[1]
      );
    }
  }
}
// 元 保留两位小数并带千分位符
Vue.filter("priceValue", value => {
  if (!value) {
    return "0.00";
  }
  return changeNum(value);
});
// 现在的时间转换
Vue.filter("getnewDate", value => {
  return value ? value.substr(0, 10) : "";
});
// 截取后四位
Vue.filter("getLast4", value => {
  return value.substr(value.length - 4, value.length);
});
// 需求 分类显示
Vue.filter("needCategoryName", value => {
  if (!value) return "";
  let newD = value.split("_");
  let text = newD.join(" - ");
  return text;
});
// 需求详情 下载文件名显示
Vue.filter("needFileName", value => {
  if (!value) return "";
  let newD = value.split("/");
  let text = newD[newD.length - 1];
  return text;
});

// 从参数里得到过滤对象
function getCon(value) {
  let new_value = {};
  value.forEach(element => {
    new_value[element.value] = element.label;
  });
  return new_value;
}
// 状态是否匿名
Vue.filter("hideName", value => {
  const newtext = {
    0: "是",
    1: "否",
  };
  return newtext[value] ? newtext[value] : "--";
});
// 通道方向
Vue.filter("trafficDirectionFilter", function(value) {
  let newtext = getCon(config.trafficDirection);
  return newtext[value] ? newtext[value] : "--";
});
